__turbopack_context__.v({
  "actions": "error-module__uHmsfa__actions",
  "backdrop": "error-module__uHmsfa__backdrop",
  "buttonPrimary": "error-module__uHmsfa__buttonPrimary",
  "container": "error-module__uHmsfa__container",
  "content": "error-module__uHmsfa__content",
  "description": "error-module__uHmsfa__description",
  "iconWrap": "error-module__uHmsfa__iconWrap",
  "title": "error-module__uHmsfa__title",
});
